module.exports = __webpack_public_path__ + "static/WorkSans-Bold-d85d301fec3067941fbe142d3e6062f0.woff2";